module.exports = __webpack_public_path__ + "nmixed_use_icon.svg";